/**
 * Returns the domain without any subdomains
 * @return {String} The parsed domain
 */
function get_pred_hostname() {
  // Get the full hostname
  var full_hostname = get_full_hostname();

  // Split the hostname
  var full_hostname_split = full_hostname.split('.');

  // Check the length
  if (full_hostname_split.length < 3) {
    return full_hostname;
  }

  // Get the last2 and last3
  var last2 = full_hostname_split.slice(-2).join('.');
  var last3 = full_hostname_split.slice(-3).join('.');

  // Check for specific endings
  if (
    ['co.uk', 'com.au', 'go.com'].indexOf(last2) !== -1 ||
    ['fiostrending.verizon.com'].indexOf(last3) !== -1 ||
    full_hostname_split.slice(-3, -2)[0].indexOf('chatter') !== -1
  ) {
    return last3;
  }

  return last2;
} // --> parse_hostname
/**
 * Obtain and return the top level hostname
 * @return {String} The hostname of the highest available window
 */
function get_full_hostname() {
  // Start at the current window
  var cWin = window;
  var myHost;
  try {
    // Loop up the parents until forced to stop
    var i = 0;
    while (i++ < 100 && cWin !== cWin.top) {
      // Try to get to the parent body
      var temp_body = cWin.parent.document.body;

      // Check for undefined (safari)
      if (typeof temp_body === 'undefined') {
        throw 'Safari Error';
      }

      // Move to the parent
      cWin = cWin.parent;
    }
  } catch (e) {}

  // Get the hostname
  if (cWin === cWin.top) {
    // Use host if on top
    myHost = cWin.location.host;
  } else {
    // Use referrer otherwise
    var matches = cWin.document.referrer.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i);
    myHost = matches && matches[1];
  }

  // Throw an error if no host
  if ([undefined, null, false].indexOf(myHost) !== -1) {
    throw "Error finding host";
  }

  return myHost;
} // --> get_full_hostname
/**
 * Return the current script element
 * @return {DOMElement} The currently executing script element
 */
function get_current_script(embedURL) {
  // The easy way
  if (typeof document.currentScript !== 'undefined' && document.currentScript.src.indexOf(embedURL) !== -1) {
    return document.currentScript;
  }

  // The IE way
  var scripts = document.getElementsByTagName('script');
  for (var i = 0; i < scripts.length; i++) {
    // Check for the script
    if (
      typeof scripts[i].src === 'string' &&
      scripts[i].src.indexOf(embedURL) !== -1
    ) {
      return scripts[i];
    }
  }

  return null;
} // --> get_current_script
/**
 * Add the query parameters to the igloo query objects
 * @param  {DOMElement} script    The current script element
 * @param  {Object}     ig_query  The query that will be passed to igloo
 * @return {Object}               The completed ig_query object
 */
function get_query_parameters(script, ig_query) {
  // Check for query string
  var query_string = script.src.split('?');
  if (query_string.length < 2) {
    return ig_query;
  }

  // Split on &
  var query_split = query_string[1].split('&');

  // Loop through the values
  for (var i = 0; i < query_split.length; i++) {
    // Get the parameters
    var key_value = query_split[i].split('=');

    // Add to the query array
    ig_query[key_value[0]] = key_value[1] || '';
  }

  return ig_query;
} // --> get_query_parameters
/**
 * Returns the highest accessible window object
 * @return {window} The highest accessible window object
 */
function get_pred_topwin() {
  // Initialize the variables
  var igloo_top = window;
  var temp_body;
  var loop_limit = 20; // Super arbitrary number
  var current_loop = 0;

  // Loop to the top window
  var localFrameElement;
  while (igloo_top !== window.top && current_loop++ < loop_limit) {
    // Get the frame element
    localFrameElement = null;
    try {
      if (typeof igloo_top.frameElement !== 'undefined' && igloo_top.frameElement !== null) {
        localFrameElement = igloo_top.frameElement;
      }
    } catch (e) {}

    // Check for synapifr
    if (localFrameElement !== null && typeof localFrameElement.classList !== 'undefined' && localFrameElement.classList.value === 'SYNAPIFR') {
      throw 'PREDICT Loop Detected';
    }

    // Try/catch for different errors
    try {
      // Safari won't throw some errors, so check for undefined
      if (typeof igloo_top.parent.document.body === 'undefined') {
        throw 'Safari Error';
      }

      // Use temp_body to induce an error
      temp_body = igloo_top.parent.document.body;

      // No errors means keep going up
      igloo_top = igloo_top.parent;
    } catch (e) {
      // If there is an error, stop because we're in an unfriendly iframe
      current_loop = loop_limit;
    }
  }

  // Return the top window
  return igloo_top;
} // --> get_pred_topwin
/**
 * This function builds the que item and adds it to the que
 * @NOTE THIS FUNCTION MODIFIES ig_params
 * @param {Window} top_window      The top accessible window
 * @param {div}    insert_location The place the product should be inserted
 * @param {Object} ig_params       The object of key-values to pass into igloo
 */
function add_que_item(top_window, insert_location, ig_params) {
  // Verify that the que exists
  top_window.igloo_que = top_window.igloo_que || new top_window.Array();

  // Make the que item
  var que_item = new top_window.Object();
  que_item.div = insert_location;
  que_item.id = top_window.igloo_que.length;
  que_item.win = window;
  que_item.ig_params = ig_params;

  // Add the que id to the string
  ig_params.que_id = que_item.id;

  // Check if we should add json to the parameters
  if (typeof top_window.igloo !== 'undefined') {
    ig_params.json = true;
  }

  // Add to the que
  top_window.igloo_que.push(que_item);
} // --> add_que_item

module.exports = {
  get_pred_hostname: get_pred_hostname,
  get_full_hostname: get_full_hostname,
  get_current_script: get_current_script,
  get_query_parameters: get_query_parameters,
  get_pred_topwin: get_pred_topwin,
  add_que_item: add_que_item
};
